import Box from "@material-ui/core/Box";
import React from "react";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import CustomCheckBox from "../../Ui/CustomCheckBox";
import { Typography } from "@material-ui/core";

interface ContractCheckboxesPropsInterface {
  isEngaged: boolean;
  isCertified: boolean;
  isSubmitted?: boolean;
  handleCertificationChecked(event: React.ChangeEvent<HTMLInputElement>): void;
  handleEngagementChecked(event: React.ChangeEvent<HTMLInputElement>): void;
}

const useStyles = makeStyles((theme) => ({
  checkboxes: {
    marginTop: 15,
  },
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
}));

const ContractCheckboxes = (props: ContractCheckboxesPropsInterface) => {
  const {
    isEngaged,
    isCertified,
    handleCertificationChecked,
    handleEngagementChecked,
  } = props;
  const classes = useStyles();
  const isSubmitted = props.isSubmitted ? props.isSubmitted : false;
  return (
    <Box className={classes.checkboxes}>
      <CustomCheckBox
        allPointer
        name="isAgree"
        isSubmitted={!!isSubmitted}
        isChecked={isCertified}
        onCheck={handleCertificationChecked}
        label={
          <Typography className={classes.text}>
            <FormattedMessage id="contract.label.certification" />
          </Typography>
        }
        errorMessage={
          <FormattedMessage id="contract.error.certifyPersonInfo" />
        }
      />
      <CustomCheckBox
        allPointer
        name="isAgree"
        isSubmitted={!!isSubmitted}
        isChecked={isEngaged}
        onCheck={handleEngagementChecked}
        label={
          <Typography className={classes.text}>
            <FormattedMessage id="contract.label.engagement" />
          </Typography>
        }
        errorMessage={<FormattedMessage id="contract.error.engagement" />}
      />
    </Box>
  );
};

export default ContractCheckboxes;
